import actions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  leaders: null,
  filteredTotal: null,
  filters: null,
  sortableColumns: [],
  loading: false,
  total: 0,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, sortableColumns } = payload;
  const leaders = data;

  return {
    ...state,
    leaders,
    total,
    filteredTotal,
    filters,
    sortableColumns,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
